document.addEventListener("DOMContentLoaded", function () {
  const modal = document.querySelector(".login-modal");
  const overlay = document.querySelector(".login-modal__overlay");
  const closeButton = document.querySelector(".login-modal__close");
  const openButtons = document.querySelectorAll("[data-login-modal]");

  if (!modal) return;

  // Open modal function
  function openModal() {
    modal.classList.add("login-modal--active");
    document.body.style.overflow = "hidden";

    // Focus first input for accessibility
    const firstInput = modal.querySelector("input");
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 100);
    }
  }

  // Close modal function
  function closeModal() {
    modal.classList.remove("login-modal--active");
    document.body.style.overflow = "";
  }

  // Open modal when clicking trigger buttons
  openButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      openModal();
    });
  });

  // Close modal when clicking close button
  if (closeButton) {
    closeButton.addEventListener("click", closeModal);
  }

  // Close modal when clicking overlay
  if (overlay) {
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        closeModal();
      }
    });
  }

  // Close modal with Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("login-modal--active")) {
      closeModal();
    }
  });

  // Handle form submission
  const form = modal.querySelector(".login-modal__form");
  if (form) {
    form.addEventListener("submit", function (e) {
      // Add any custom form handling here if needed
      // For now, let Shopify handle the default customer login
    });
  }

  // Handle "show password" toggle if present
  const passwordToggles = modal.querySelectorAll("[data-password-toggle]");
  passwordToggles.forEach((toggle) => {
    toggle.addEventListener("click", function () {
      const input = this.previousElementSibling;
      const isPassword = input.type === "password";

      input.type = isPassword ? "text" : "password";
      this.textContent = isPassword ? "Hide" : "Show";
    });
  });
});
